import { getSvgPath } from 'figma-squircle';

/** Matches `TELLOPORT_RADIUS.lg` (12px) — keep in sync with design tokens. */
export const DEFAULT_SQUIRCLE_CORNER_RADIUS = 12;
export const DEFAULT_SQUIRCLE_SMOOTHING = 0.6;

export interface BuildSquircleClipPathArgs {
    width: number;
    height: number;
    cornerRadius?: number;
    smoothing?: number;
    preserveSmoothing?: boolean;
}

/**
 * Builds a CSS `clip-path: path('…')` value for a Figma-style G2 squircle.
 * Returns undefined when size is not yet measurable.
 */
export function buildSquircleClipPath(args: BuildSquircleClipPathArgs): string | undefined {
    const width = Math.round(args.width);
    const height = Math.round(args.height);
    if (width <= 0 || height <= 0) {
        return undefined;
    }

    const cornerRadius = args.cornerRadius ?? DEFAULT_SQUIRCLE_CORNER_RADIUS;
    const cornerSmoothing = args.smoothing ?? DEFAULT_SQUIRCLE_SMOOTHING;
    const path = getSvgPath({
        width,
        height,
        cornerRadius,
        cornerSmoothing,
        preserveSmoothing: args.preserveSmoothing ?? true
    });

    return `path('${path}')`;
}
